import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Globals } from "../globals";
import { Router } from "@angular/router";
import { MsalService} from "../services/msal.service";
import * as _ from "underscore";

var mockIdentity = {
  id_token:
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Im5PbzNaRHJPRFhFSzFqS1doWHNsSFJfS1hFZyIsImtpZCI6Im5PbzNaRHJPRFhFSzFqS1doWHNsSFJfS1hFZyJ9.eyJhdWQiOiIwN2RmNGQwMC1iMjZmLTQ3ZjEtYmEwMC0yNDRlZWY0NTUwMmUiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC81ZGU5NmM5Ni1jODdjLTRkY2UtYWFkOS1mNWM1NTdiNTJhYzEvIiwiaWF0IjoxNjE5MDI3MjYzLCJuYmYiOjE2MTkwMjcyNjMsImV4cCI6MTYxOTAzMTE2MywiYWlvIjoiQVdRQW0vOFRBQUFBYU83bXErZlFHeXJYZHQ3S3dPc0lMRHBMaE5yQVc1THRLWTgxaHMzYVBFQTliSjBTalIyU04xOC9MRlVOTDlZVmM4NWJkdVprZ0phTDd5NW94Znk5RFNRNGhhS1M5THhLZFRMYktSMEkzWVVvWk15Zytmd0Q1OWxjR0Z3S2VRbVoiLCJhbXIiOlsicHdkIiwibWZhIl0sImZhbWlseV9uYW1lIjoiUk9DSEEiLCJnaXZlbl9uYW1lIjoiRGlvbmlzaW8iLCJpcGFkZHIiOiI1LjUxLjIyMC4xNyIsIm5hbWUiOiJST0NIQSBEaW9uaXNpbyIsIm5vbmNlIjoiOWJkYjlmYWU3ZmNiNDY5ZGE1OGVlZTRmYzNkN2IxYWNfMjAyMTA0MjExNzU3NDMiLCJvaWQiOiI4NmZjZmNmMi01OGY1LTQ3YzgtYjk2Mi1kZTU1YTBlYjAwZTgiLCJvbnByZW1fc2lkIjoiUy0xLTUtMjEtMzE5NTI1Mzg4Ny02NjcyMDUzMjktMjI1MzE5OTQ4My0yNTM2MjMiLCJyaCI6IjAuQVFJQWxtenBYWHpJemsycTJmWEZWN1Vxd1FCTjN3ZHZzdkZIdWdBa1R1OUZVQzRDQUZjLiIsInN1YiI6IlNYd1JsaURJdWh3bC11Q1NfMEI2bGl0dFZXMEh2QVp5UGZnaTRHSjJSNFkiLCJ0aWQiOiI1ZGU5NmM5Ni1jODdjLTRkY2UtYWFkOS1mNWM1NTdiNTJhYzEiLCJ1bmlxdWVfbmFtZSI6ImRpb25pc2lvLnJvY2hhQHdhdmVzdG9uZS5jb20iLCJ1cG4iOiJkaW9uaXNpby5yb2NoYUB3YXZlc3RvbmUuY29tIiwidXRpIjoiNlc3VnF6MzFwa2lDMmRQcXJoOENBQSIsInZlciI6IjEuMCJ9.GfVSStP3tCZ2i3qdeJBmr9Cg-ecMCWLCHTMDoYdbi5PHGUx6WRsHv8cSzX_bEfJVJ9HZklOOmEVdUzLPcFERyiBhNKuFPahioD7LMRGaovYr5wIL7FrCm-fTen5P1YIB1K9yNH3F0kVmxaU3xbvo0NuGL49amg70_yTe4H9pW_U6B6BfyY6OamyDHYMWvOev03P3Cu_6iBGVCZQRUsGc8XBj29HXyqWLZKyJpb7d61uKmIBdYa8SwBNQP7Q-mIrlo-re3MrEN6igj2nIDlJz2E-X4JBni6hrvxWhHQHZldbE537JJAJ41L9hnO0goZwFYH6wYgbn2FUfyB1gni_w0Q",
  provider_name: "aad",
  user_claims: [
    { typ: "aud", val: "07df4d00-b26f-47f1-ba00-244eef45502e" },
    { typ: "iss", val: "https://sts.windows.net/5de96c96-c87c-4dce-aad9-f5c557b52ac1/" },
    { typ: "iat", val: "1619027263" },
    { typ: "nbf", val: "1619027263" },
    { typ: "exp", val: "1619031163" },
    {
      typ: "aio",
      val: "AWQAm/8TAAAAaO7mq+fQGyrXdt7KwOsILDpLhNrAW5LtKY81hs3aPEA9bJ0SjR2SN18/LFUNL9YVc85bduZkgJaL7y5oxfy9DSQ4haKS9LxKdTLbKR0I3YUoZMyg+fwD59lcGFwKeQmZ",
    },
    { typ: "http://schemas.microsoft.com/claims/authnmethodsreferences", val: "pwd" },
    { typ: "http://schemas.microsoft.com/claims/authnmethodsreferences", val: "mfa" },
    { typ: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname", val: "ROCHA" },
    { typ: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname", val: "DionisioTest" },
    { typ: "ipaddr", val: "5.51.220.17" },
    { typ: "name", val: "ROCHA DionisioTest" },
    { typ: "nonce", val: "9bdb9fae7fcb469da58eee4fc3d7b1ac_20210421175743" },
    { typ: "http://schemas.microsoft.com/identity/claims/objectidentifier", val: "86fcfcf2-58f5-47c8-b962-de55a0eb00e8" },
    { typ: "onprem_sid", val: "S-1-5-21-3195253887-667205329-2253199483-253623" },
    { typ: "rh", val: "0.AQIAlmzpXXzIzk2q2fXFV7UqwQBN3wdvsvFHugAkTu9FUC4CAFc." },
    { typ: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier", val: "SXwRliDIuhwl-uCS_0B6littVW0HvAZyPfgi4GJ2R4Y" },
    { typ: "http://schemas.microsoft.com/identity/claims/tenantid", val: "5de96c96-c87c-4dce-aad9-f5c557b52ac1" },
    { typ: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name", val: "dionisio.rocha@wavestone.com" },
    { typ: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/upn", val: "dionisio.rocha@wavestone.com" },
    { typ: "uti", val: "6W7Vqz31pkiC2dPqrh8CAA" },
    { typ: "ver", val: "1.0" },
  ],
  user_id: "dionisio.rocha@wavestone.com",
};

@Injectable({
  providedIn: "root",
})
export class AzureService {
  constructor(
    private auth: MsalService,
    private http: HttpClient,
    private globals: Globals,
    private router: Router
  ) {}

  async getAzureToken(): Promise<any> {
    try {
      if (environment.version != "2025b") {
        if (!environment.production) {
          this.globals.token = mockIdentity.id_token;
          this.globals.userEmail = mockIdentity.user_id;
          this.globals.userFirstName = _.findWhere(mockIdentity.user_claims, {
            typ: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname",
          }).val;
          this.globals.userLastName = _.findWhere(mockIdentity.user_claims, { typ: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname" }).val;
          return { status: 200 };
        } else {
          let response = await this.http.get(environment.frontendUrl + "/.auth/me").toPromise();
          this.globals.token = response[0].id_token;
          this.globals.userEmail = response[0].user_id;
          this.globals.userFirstName = _.findWhere(response[0].user_claims, {
            typ: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname",
          })["val"];
          this.globals.userLastName = _.findWhere(response[0].user_claims, {
            typ: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname",
          })["val"];

          return { status: 200 };
        }
      } else {
          await this.auth.login();
      }
    } catch (error) {
      if (error.status == 401) {
        //v2-window.location.href = environment.authErrorRedirectUrl;
        await this.auth.login();
      } else {
        return error;
      }
    }
  }
}
